import { render, staticRenderFns } from "./DetachedTotal.vue?vue&type=template&id=2ef8b1ed&"
import script from "./DetachedTotal.vue?vue&type=script&lang=js&"
export * from "./DetachedTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports